/**
 * A fresh id for a game or an arena. `crypto.randomUUID` exists only on a secure page (https or
 * localhost), so the editor opened over a plain-http address on the local network threw on its
 * first render (editor:bugs#10); `crypto.getRandomValues` works on any page.
 */
export function newId(): string {
  if (typeof crypto.randomUUID === 'function') {
    try {
      return crypto.randomUUID();
    } catch {
      // Not a secure page after all: made by hand below.
    }
  }
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;
  const hex = [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
